import React from 'react'
import './NoPage404.scss'

const NoPage404 = () => {
  return (
    <div>Error 404: Page Not Found</div>
  )
}

export default NoPage404